/**
 * Created by ray on 2017/8/21.
 */
import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {HttpService} from './http.service';
import {LookupItem} from "../vo/lookupItem";
import {SelectItem} from "primeng/primeng";
import {Constants} from "../constants";

@Injectable()
export class LookupService {

    public isLoaded:boolean;
    public lookups = [];

    constructor(private http:HttpService, private constants:Constants) {
    }

    loadLookups() {
        this.http.auth_get('lookup', null, data => {
            this.lookups = data;
            this.isLoaded = true;
        });
    }

    getLookup(name, callback:Function) {
        let param;
        if (name) {
            param = new HttpParams().set('name', name);
        }
        this.http.auth_get('lookup/get', param, data => {
            let t_list:SelectItem[] = [];
            for (const item of data) {
                t_list.push({label: item.name, value: item.id});
            }
            callback(t_list);
        });
    }

    getMasLoc(userId, callback:Function, type?) {
        let params:HttpParams = new HttpParams().set('userId', userId);
        if (type) {
            params = new HttpParams().set('userId', userId).set('type', type);
        }
        this.http.auth_get('lookup/masLoc', params, result=> {
            const items = result.res;
            let list = [];
            list.push({value: null, label: 'All'});
            for (const item of items) {
                list.push({value: item.strVal, label: item.name});
            }
            callback(list);
        });
    }

    getMasLocByCcn(ccn, callback:Function) {
        let params:HttpParams = new HttpParams().set('ccn', ccn);

        this.http.auth_get('lookup/macLocByccn', params, result=> {
            callback(result);
        });
    }


    getDellConfig(partType, callback, errorback) {
        this.http.auth_get('lookup/cfg-dell', new HttpParams().set('partType', partType), result=> {
            let list = [{value: null, label: 'All'}];
            const items = result.res;
            for (const item of items) {
                list.push({value: item.strVal, label: item.name});
            }
            callback(list);
        });
    }

    getHpConfig(partType, callback, errorback) {
        this.http.auth_get('lookup/cfg-hp', new HttpParams().set('partType', partType), result=> {
            let list = [{value: null, label: 'All'}];
            const items = result.res;
            for (const item of items) {
                list.push({value: item.strVal, label: item.name});
            }
            callback(list);
        });
    }

    getGloviaCusLoc(cusId: number, callback){
        this.http.auth_post('lookup/glv/cusLoc',cusId, callback);
    }

    getGlvMasloc(ccn, callback){
      this.http.auth_get('lookup/glv/masloc',new HttpParams().set('ccn', ccn), callback);
    }

    getCcn(callback:Function) {
      this.http.auth_get('lookup/ccn', null, callback);
    }

    getGlvCcn(callback:Function) {
      this.http.auth_get('lookup/glv/ccn', null, callback);
    }

    getSelectItems(name):SelectItem[] {
        const items = this.lookups[name];
        let t_list:SelectItem[] = [];

        for (const item of items) {
            t_list.push({label: item.name, value: item.id});
        }
        return t_list;
    }

    checkCcnMasloc(ccn, masloc, callback:Function){
      let params:HttpParams = new HttpParams().set('ccn', ccn).set('masloc', masloc);;

      this.http.auth_get('lookup/checkCcnMasloc', params, result=> {
        callback(result);
      });
    }

    addGlvCcnMasloc(ccn, masloc, callback){

      let param = {
        'ccn' : ccn,
        'masloc' : masloc
      }
      this.http.auth_post('account/glvCcnMasloc/add',param, callback);
    }

    reloadLookup(callback){
        this.http.auth_get('lookup/reload', null, result=> {
            this.loadLookups();
            callback(result);
        });
    }

    get(name, callback:Function){
        if(this.isLoaded){
            callback(this.lookups[name]);
        }else{
            const param = new HttpParams().set('name', name);
            this.http.auth_get('lookup/get', param, data => {
                callback(data);
            });
        }
    }

    getAWBUrl(ccn, carrier, awb){
        let url = '';
        this.lookups[this.constants.lookup_awb_url].forEach(item=>{
            if(item.desc === ccn && item.name === carrier){
                url = item.strVal.replace('###TRACK_NUMBER###', awb);
                return false;
            }
        });
        return url;
    }

    getProgram(callback:Function, type?) {
        this.http.auth_get('lookup/program', null, result=> {
            const items = result.res;
            let list = [];
            list.push({value: '', label: 'All'});
            for (const item of items) {
                list.push({value: item.name, label: item.name});
            }
            callback(list);
        });
    }

    getRefreshDate(callback:Function, type?) {
        this.http.auth_get('lookup/refreshDate', null, result=> {
            const items = result.res;
            callback(items);
        });
    }

    getInvoiceDate(loginId, callback: Function) {
        let params: HttpParams = new HttpParams().set('loginId', loginId);
        this.http.auth_get('lookup/invoiceDate', params, result => {
            const items = result.res;
            let list = [];
            list.push({value: null, label: 'Any'});
            for (const item of items) {
                list.push({value: item.strVal, label: item.name});
            }
            callback(list);
        });
    }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/service/lookupService.ts